import { ListCategoryResult } from '../client-domain.types';

export const categories: ListCategoryResult = {
  paging: {
    count: 1000,
    currentPage: 0,
    total: 18,
    totalPages: 1,
  },
  categories: [
    {
      categoryId: '1acad2b3-8ca4-4a49-9411-3fe0352cf3ca',
      title: 'Basta 28',
      longDescription: 'Basta 28',
      categoryCode: 'CAT:3424215764',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '95eb08ff-abbf-445a-bcd5-374cf0ab95d4:1:1',
      beaconName: 'Basta 28',
    },
    {
      categoryId: '535faabf-55c1-4ec4-8df7-87c2ebf9ecd0',
      title: 'Bowlify Superfoods',
      longDescription: 'Bowlify Superfoods',
      categoryCode: 'CAT:6118277816',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '087bac67-2624-4479-835a-db9f75e14386:1:1',
      beaconName: 'Bowlify Superfoods',
    },
    {
      categoryId: '92247ddf-e9a7-496c-b509-4828accac838',
      title: 'Broth',
      longDescription: 'Broth',
      categoryCode: 'CAT:5481687715',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '98f6d5d0-2489-4b2b-a6c4-1bf2e8c06918:1:1',
      beaconName: 'Broth',
    },
    {
      categoryId: 'a8fd791a-2a69-434c-8ab6-cc6ccf632427',
      title: 'I Heart Mac and Cheese NRO Deal',
      longDescription: 'I Heart Mac and Cheese NRO Deal',
      categoryCode: 'CAT:7091193858',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'cdc19618-b4be-4bed-99b5-5a02d6a42186:1:1',
      beaconName: 'I Heart Mac and Cheese NRO Deal',
    },
    {
      categoryId: 'c207acce-260e-4c7e-9cc0-56faceb54bbe',
      title: "It's Boba Time",
      longDescription: "It's Boba Time",
      categoryCode: 'CAT:4988250929',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'd9f3f841-cb2a-4F67-9593-29d1c4b66b0a:1:1',
      beaconName: "It's Boba Time",
    },
    {
      categoryId: '7b8c4fb8-b83e-4d9c-b019-089fe0705673',
      title: "Juan's Mexican Grill",
      longDescription: "Juan's Mexican Grill",
      categoryCode: 'CAT:7438878780',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '3f08087a-40d6-4a17-9f86-3a7926a9eefb:1:1',
      beaconName: "Juan's Mexican Grill",
    },
    {
      categoryId: 'c43146f8-3d10-45a1-90a1-17a2b139b354',
      title: "Julia & Henry's",
      longDescription: "Julia & Henry's",
      categoryCode: 'CAT:6295349477',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'd82811a2-26f3-41ed-93cf-6bcd4c15ee8a:1:1',
      beaconName: "Julia & Henry's",
    },
    {
      categoryId: 'c1ec680f-e3c6-439a-a30f-1eb472529474',
      title: 'King Mediterrano',
      longDescription: 'King Mediterrano',
      categoryCode: 'CAT:6979069909',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'f36977d0-f22d-45b0-b169-e5473036e983:1:1',
      beaconName: 'King Mediterrano',
    },
    {
      categoryId: '8b4435b7-86d1-4e93-9de7-9bb54d68820e',
      title: 'Manchepani',
      longDescription: 'Manchepani',
      categoryCode: 'CAT:4294740877',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '5c6a14b6-3fca-4b1a-8397-307ec8b27067:1:1',
      beaconName: 'Manchepani',
    },
    {
      categoryId: 'd918524b-6cc7-4d8b-bf22-50210dbf0c64',
      title: 'Milligram Coffee & Kitchen',
      longDescription: 'Milligram Coffee & Kitchen',
      categoryCode: 'CAT:1647085076',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '03625e82-d569-4762-82f5-b9f30b3e3628:1:1',
      beaconName: 'Milligram Coffee & Kitchen',
    },
    {
      categoryId: 'c8772a6d-c4d9-4af8-9f14-3ed5dce17783',
      title: 'Milwaukee Burger Company',
      longDescription: 'Milwaukee Burger Company',
      categoryCode: 'CAT:3215523401',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'f27d26f7-8371-4f4a-bf4c-58714f65477a:1:1',
      beaconName: 'Milwaukee Burger Company',
    },
    {
      categoryId: 'b88d71b1-3a26-476d-adaa-a0646e25f3ae',
      title: 'Port City',
      longDescription: 'Port City',
      categoryCode: 'CAT:4931456198',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '1ee2bce8-6d13-421f-b77e-a259c3323637:1:1',
      beaconName: 'Port City',
    },
    {
      categoryId: '2ebfad0a-75a7-4fe0-ac76-656a18efde02',
      title: 'Press 195',
      longDescription: 'Press 195',
      categoryCode: 'CAT:8719456518',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '1cf6406b-e29d-4a6e-9260-dbc8df3538b2:1:1',
      beaconName: 'Press 195',
    },
    {
      categoryId: '8e41e8a7-5e1d-4384-807a-f2b13b5dba3f',
      title: 'Pure Burger',
      longDescription: 'Pure Burger',
      categoryCode: 'CAT:2549278440',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '4eb7ecbc-162f-4135-a09b-546c5ccac451:1:1',
      beaconName: 'Pure Burger',
    },
    {
      categoryId: '4cd68697-1ed9-4977-8141-6536e7d13352',
      title: 'Red Rock Bakery & Deli',
      longDescription: 'Red Rock Bakery & Deli',
      categoryCode: 'CAT:2693921551',
      icon: '',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'c7eb5c4c-0f54-46c0-b9df-98e831bcf8c4:1:1',
      beaconName: 'Red Rock Bakery & Deli',
    },
    {
      categoryId: 'd9d0b618-3c84-485a-8c8c-2c6dd3999963',
      title: 'TacoMyGuey',
      longDescription: 'TacoMyGuey',
      categoryCode: 'CAT:2317317319',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'e390072a-48f0-4044-8b2b-70ca2e2fc33f:1:1',
      beaconName: 'TacoMyGuey',
    },
    {
      categoryId: 'cfe0d938-3c90-460c-805d-e3ddc2b200ab',
      title: 'Togather Restaurant Group',
      longDescription: 'Togather Restaurant Group',
      categoryCode: 'CAT:2934369498',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: 'f4f22f6f-72d3-407b-98a4-5640a2f3eb4c:1:1',
      beaconName: 'Togather Restaurant Group',
    },
    {
      categoryId: '13cd6b1c-c7d2-49ec-91c6-d8c0a1ec5662',
      title: 'TulasKitcen',
      longDescription: 'TulasKitcen',
      categoryCode: 'CAT:9616227113',
      merchants: ['4c4ade61-7973-46f0-820f-4bf5bc783e0c'],
      beaconId: '734e1fd9-9110-4001-9efd-bed55cac7dbe:1:1',
      beaconName: 'TulasKitchen',
    },
  ],
};
